export default {
  SELECT: (state, payload) => {
    state[payload.key] = payload.value;
  },
  LAUNCH_CONFIG: (state) => {
    state.launch_config = true;
  },
  LAUNCH_STOCK: (state) => {
    state.launch_stock = true;
  },
  LAUNCH_PRICE: (state) => {
    state.launch_price = true;
  },
  COLOR_FILTER_CODE: (state, payload) => {
    let filtered = state.product_config_color_reference.filter(record => record['TCOL'].toString().startsWith(payload['color_code']));
    state.product_config_color = filtered;
  },
  RESET_PRODUCT_PAGE: state => {
    state.fmod = '';
    state.ftail1 = '';
    state.ftail2 = '';
    state.fopt = '';
    state.fcol = '';
    state.fmarq = '';
    state.fgrpcol = '';
    state.fqte = '';
    state.total_price = 0;
    state.stock_availibility = '';
    state.price_unit = '';
    state.descm_long = '';
    state.descm_court = '';
    state.desc_prod = '';
    state.product_config_width = [];
    state.product_config_packaging = [];
    state.product_config_color = [];
    state.product_config_color_reference = [];
    state.division_img = [];
  },
  RESET_PRODUCT_CONFIG: (state, payload) => {

    console.error(payload)
    // state.fmod = '';
    // state.ftail1 = '';
    // state.ftail2 = '';
    // state.fopt = '';
    // state.fcol = '';
    // state.fmarq = '';
    // state.fgrpcol = '';
    // state.fqte = '';
    // state.total_price = 0;
    // state.stock_availibility = '';
    // state.price_unit = '';

    // state[payload.key] = payload.val;
  },
  SET: (state, payload) => {
    if (Array.isArray(payload)) {
      payload.map(obj => {
        state[obj.key] = obj.value;
      });
    } else {
      state[payload.key] = payload.value;
    }
  },
};